import { Button } from "@/design-system/components/ui";

interface LoadMoreFooterProps {
  loadedCount: number;
  total: number;
  loading: boolean;
  onLoadMore: () => void;
}

/**
 * UAT FixBatch-06 FIND-31/FIND-32 — "Showing N of Total" count with a Load more
 * button for offset/limit ("Load more") paginated queues. The button is hidden
 * once every matched row is loaded.
 */
export function LoadMoreFooter({ loadedCount, total, loading, onLoadMore }: LoadMoreFooterProps) {
  return (
    <div className="flex flex-col items-center gap-space-2 py-space-3" data-testid="load-more-footer">
      <p className="text-caption text-gray-mid">
        Showing {loadedCount} of {total}
      </p>
      {loadedCount < total && (
        <Button
          variant="secondary"
          size="sm"
          type="button"
          disabled={loading}
          onClick={onLoadMore}
          data-testid="load-more"
        >
          {loading ? "Loading…" : "Load more"}
        </Button>
      )}
    </div>
  );
}
